<template>
  <header class="ren-decoration-cp ren-decoration-cp-cms-site-header">
    <strong>{{ siteName }}</strong>
    <span v-if="showSwitch">{{ switchLabel }}</span>
    <span v-if="showSearch">{{ searchPlaceholder }}</span>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const data = computed(() => previewDataRecord(props.componentData))
const siteName = computed(() => stringValue(data.value.siteName ?? data.value.name ?? props.component.props?.title, '站点'))
const showSwitch = computed(() => booleanValue(props.component.props?.showSwitch, true))
const switchLabel = computed(() => stringValue(props.component.props?.switchLabel, '切换'))
const showSearch = computed(() => booleanValue(props.component.props?.showSearch, true))
const searchPlaceholder = computed(() => stringValue(props.component.props?.searchPlaceholder, '搜索内容'))
</script>

<style scoped>
.ren-decoration-cp-cms-site-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ren-decoration-cp-cms-site-header span {
  color: var(--ren-theme-muted);
  font-size: 12px;
}
</style>
